import common from './common.json';
import errorPage from './errorPage.json';
import landingPage from './landingPage.json';
import validation from './validation.json';
import legitimationPage from './legitimationPage.json';
import upload from './upload.json';

export const i18n = {
  common,
  errorPage,
  landingPage,
  validation,
  legitimationPage,
  upload
};

export default i18n;
